import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { deleteGradeOption, getGradeWeight } from '../../actions/directory'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
export default function GradeWeight() {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { gradeWeight } = useSelector(state => state.directory)

  const [selectedItem, setSelectedItem] = useState(null)
  const [addMode, setAddMode] = useState(false)
  const [modalKey, setModalKey] = useState(0)
  const [confirmation, setConfirmation] = useState(false);
  const [sortField, setSortField] = useState('weight')
  const [sortAsc, setSortAsc] = useState(true)

  useEffect(() => {
    dispatch(getGradeWeight());
  }, [])

  const handleSort = (field) => {
    if (sortField === field) setSortAsc(v => !v)
    else { setSortField(field); setSortAsc(true) }
  }

  const sortedList = useMemo(() => {
    if (!gradeWeight) return []
    return [...gradeWeight].sort((a, b) => {
      const aVal = a[sortField] ?? ''
      const bVal = b[sortField] ?? ''
      if (typeof aVal === 'number' && typeof bVal === 'number')
        return sortAsc ? aVal - bVal : bVal - aVal
      return sortAsc
        ? String(aVal).localeCompare(String(bVal), 'ru')
        : String(bVal).localeCompare(String(aVal), 'ru')
    })
  }, [gradeWeight, sortField, sortAsc])

  // useEffect(() => {
  //   selectedItem &&
  //   handleCheck(selectedItem)
  // }, [selectedItem])


  const openModal = (data) => () => {
    setAddMode(true)
    setSelectedItem(data || {})
    setModalKey(k => k + 1)
  }

  const closeModal = () => {
    setSelectedItem(null)
    setAddMode(false)
  }
  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteGradeOption(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };
  const renderLi = (data) => {
    const { weight, enabled, color } = data
    return (
      <tr key={weight}>
        <td name='weight' onClick={openModal(data)}>{weight}</td>
        <td name='color' onClick={openModal(data)}>
          <span className={styles.colorChip} style={{ backgroundColor: `#${color}` }} />
        </td>
        <td name='enabled' onClick={openModal(data)}>{enabled ? 'Да' : 'Нет'}</td>
        <td><i className={styles.trash} onClick={(e) => { e.stopPropagation(); setConfirmation({ id: weight }) }}><BiTrash /></i></td>
      </tr>
    )
  }
  return (
    <div className={styles.wrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить вес оценки ${confirmation.id}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      <Modal
        key={modalKey}
        closeModal={closeModal}
        selectedItem={selectedItem}
        addMode={addMode}
      />
      <header className={styles.header}>
        <h1>Веса оценок</h1>
      </header>
      <main className={styles.content}>
        <Table className={styles.table} maxHeight="calc(-300px + 100vh)">
          <thead>
            <tr>
              <th onClick={() => handleSort('weight')} style={{ cursor: 'pointer', width: '15%' }}>Вес</th>
              <th style={{ width: '45%' }}>Цвет</th>
              <th onClick={() => handleSort('enabled')} style={{ cursor: 'pointer', width: '20%' }}>Доступен</th>
              <th style={{ width: '20%' }}>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {sortedList.map(renderLi)}
          </tbody>
        </Table>
        <div className={styles.actions}>
          <Button style={{ padding: '.5rem 1.5rem' }} onClick={openModal()}>
            <IoIosAdd size={30} />
            Добавить
          </Button>
          <span className={styles.counter}>Всего записей: {gradeWeight?.length || 0}</span>
        </div>
      </main>
    </div>
  )
}
